import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MailRoundedIcon from '@mui/icons-material/MailRounded';

import Form from './Form';
import graph from './graph';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { isEmptyObject } from 'helpers/formatObject';
import { NewDialog, NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';

export default function FCM({ ids, title, refetch }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState(true);
  const { userToken } = useSelector((state) => state.auth);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const [formUpdate, { loading }] = useMutation(graph.send.query, {
    context: {
      serviceName: graph.send.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onChange = ({ formData, errors }) => {
    setFormData(formData);
    setFormError(Boolean(errors.length > 0));
  };

  const onSubmit = async () => {
    try {
      const { data, errors } = await formUpdate({
        variables: {
          ...formData,
          user_ids: ids.map((user) => user.id),
          image: 'https://core.hyperano.ir/app/media/push.webp',
          icon: 'https://www.digikala.com/statics/img/png/specialCarousel/freshbasket.png',
          click_action: 'https://hyperano.ir/store1',
        },
      });
      if (!errors) {
        // refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.send.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  return (
    <>
      <Tooltip title={<FormattedMessage id={title} />}>
        <IconButton
          size="medium"
          color="secondary"
          onClick={onOpen}
          disabled={loading}
          sx={{ bgcolor: 'action.hover' }}
        >
          <MailRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <NewDialog label="create" open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={2} rowGap={2} alignItems="center" justifyContent="center" bgcolor="background.paper">
            <Avatar
              variant="rounded"
              sx={{
                width: 120,
                height: 120,
                borderRadius: 4,
                bgcolor: 'action.hover',
              }}
              src="/assets/icons/glass/message.svg"
            />
            <Typography variant="subtitle1">ارسال پیام</Typography>
            <Stack width="100%">
              <Form formData={formData} onChange={onChange} />
            </Stack>
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            size="large"
            variant="contained"
            onClick={onSubmit}
            sx={{ minWidth: 80 }}
            disabled={loading || formError}
          >
            <FormattedMessage id="create" />
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
